package app.bloomey.web.pages

import androidx.compose.runtime.Composable
import app.bloomey.web.components.sections.NavHeader
import app.bloomey.web.components.widgets.SiteButton
import app.bloomey.web.components.widgets.SvgLoader
import app.bloomey.web.core.res.*
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


val SpanStyle by ComponentStyle {
    cssRule(" span") {
        Modifier.color(Colors.White)
    }
}

@Page
@Composable
fun LandingPage() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakPoint = rememberBreakpoint()
    Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
        NavHeader()
        Box(
            modifier = Modifier.height(clamp(max = 200.vh, min = 100.vh, value = 100.vh))
                .background(sitePalette.brand.primary)
                .fillMaxSize()
                .position(Position.Relative)
                .overflow(Overflow.Hidden)
        ) {
            Image(
                src = Res.Assets.logoPattern, modifier = Modifier.height(99.percent)
                    .position(Position.Absolute)
                    .right((-2).percent)
                    .top(0.px)
            )
            SimpleGrid(
                numColumns(base = 1, md = 2), modifier = Modifier.padding(leftRight = 2.cssRem, topBottom = 6.cssRem)
                    .zIndex(1)
                    .gap(2.cssRem)
                    .then(SpanStyle.toModifier())
                    .fillMaxWidth()
                    .maxWidth(100.percent)
            ) {
                Column(modifier = Modifier.padding(topBottom = 4.cssRem).fillMaxWidth()) {
                    SpanText(
                        "Videos made fun", modifier = Modifier
                            .fontFamily("Gluten")
                            .fontWeight(700)
                            .fontSize(
                                if (breakPoint < Breakpoint.MD)
                                    4.em
                                else
                                    5.8.em
                            )
                            .lineHeight(1.em)
                            .margin(bottom = 3.2.cssRem)
                    )
                    SpanText(
                        "Bloomey is an all-in-one video app designed to keep your family entertained and safe",
                        modifier = Modifier.margin(bottom = 4.5.cssRem)
                            .fontSize(24.px)
                            .fontWeight(FontWeight.SemiBold)
                    )
                    SpanText(text = "Download the app", modifier = Modifier.margin(bottom = 1.5.cssRem))
                    Span(attrs = Modifier.margin(bottom = 3.2.cssRem).toAttrs()) {
                        SpanText(
                            "Bloomey fosters a safe space for your children to explore enriching and age-appropriate" +
                                    " videos while offering the flexibility to download content for offline viewing." +
                                    " Download Bloomey today and create a world of wonder for your children, all while" +
                                    " giving yourself peace of mind. ",
                        )
                        SpanText("\n\nYou can contact us at ")
                        Link("mailto:planaapp23@gmail.com", modifier = Modifier.color(Color.rgb(245, 169, 1))) {
                            Text("planaapp23@gmail.com")
                        }
                    }
                    SimpleGrid(
                        numColumns(1, sm = 2, md = 2), modifier = Modifier.gap(2.4.cssRem)
                            .overflow(Overflow.Auto)
                    ) {
                        SiteButton(onClick = {}) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                SvgLoader(
                                    Res.Assets.googlePlay,
                                    modifier = Modifier.margin(right = 12.px).height(32.px)
                                )
                                SpanText(
                                    "Google play", modifier = Modifier.fontSize(1.2.em)
                                        .whiteSpace(WhiteSpace.Normal)
                                )
                            }
                        }

                        SiteButton(onClick = {}) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                SvgLoader(
                                    Res.Assets.apple,
                                    modifier = Modifier.margin(right = 12.px).height(32.px),
                                    color = Colors.White
                                )
                                SpanText(
                                    "Apple Store",
                                    modifier = Modifier.fontSize(1.2.em)
                                        .whiteSpace(WhiteSpace.Normal)
                                )
                            }
                        }
                    }
                }
                Box(
                    modifier = Modifier
                        .fillMaxSize().position(Position.Relative).displayIfAtLeast(Breakpoint.MD)
                ) {
                    Image(
                        src = Res.Assets.app_preview, modifier = Modifier
                            .maxHeight(80.percent)
                            .position(Position.Absolute)
                            .bottom(10.percent)
                            .right(2.cssRem)
                            .maxWidth(calc { 100.percent - 2.cssRem })
                    )

                    Image(
                        src = Res.Assets.cookie, modifier = Modifier
                            .position(Position.Absolute)
                            .bottom(0.px)
                            .left(0.px)
                            .width(42.percent)
                    )
                    Image(
                        src = Res.Assets.signature, modifier = Modifier
                            .position(Position.Absolute)
                            .bottom(0.px)
                            .right(0.px)
                            .maxWidth(30.percent)
                            .maxHeight(27.percent)
                    )
                }
            }
        }
    }
}